export default __webpack_public_path__ + "static/media/goods6.d717a32b.png";